var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticStyle:{"background":"#f6f8fa"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('SaCounts')],1)],1),_c('div',{staticClass:"chart_data"},[_c('div',{attrs:{"id":"chart"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }